var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbletoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 136,
    height: 28,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136 0H0v28h136V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#85356F",
    d: "m38.3 21.6-2.1 6h-5.5L40.4 0h4.9L55 27.6h-5.5l-2.1-6h-9.1Zm4.5-14.4-3.2 10H46l-3.3-10Zm18.5 20.4h-5V0h5.2v10.6a5.2 5.2 0 0 1 5-3.8c3.9 0 7.6 2.7 7.6 8.7v3.7c0 6-3.9 8.8-7.6 8.8-2.6 0-4.3-1.8-5.2-3.2v2.8ZM69 15.7c0-2.7-1.8-4-3.7-4-2 0-3.8 1.3-3.8 4V19c0 2.7 1.8 4 3.8 4 1.9 0 3.7-1.3 3.7-4v-3.3Zm20.6 2.7v1c0 2.3 1.3 4 3.8 4 1.8 0 3-1 3.5-2.3h5.2c-.8 4.2-3.7 6.9-8.7 6.9-5.7 0-8.9-3.7-8.9-9.3V16c0-5.7 3.2-9.4 9-9.4 5.6 0 8.8 3.7 8.8 9.4v2.3H89.6Zm0-2.9h7.6v-.9c-.3-2-1.6-3.2-3.8-3.2-2 0-3.3 1-3.7 2.7v1.4Zm-6.2 8.2v3.9h-1.9c-3.5 0-5-1.9-5-5.2V0h5v21.9c0 1 .8 1.8 1.8 1.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C177B6",
    d: "M114.1 5.2v22.4h-5.3V5.2h-7.5V0h20.4v5.2H114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C177B6",
    d: "M127.2 6.7c-5.7 0-9 3.7-9 9.4v2.5c0 5.7 3.3 9.4 9 9.4s8.9-3.7 8.9-9.4V16c0-5.6-3.2-9.3-9-9.3Zm3.8 12.6c0 2.4-1.4 4-3.8 4-2.5 0-3.8-1.6-3.8-4v-4c0-2.3 1.3-3.9 3.8-3.9 2.4 0 3.8 1.6 3.8 4v4ZM26 25.3h-5.3v-20c0-3 2.4-5.3 5.3-5.3v25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E99",
    d: "M22.3 26.8 12.5 9.5a5.4 5.4 0 0 1 1.9-7.3L26 22.7l-3.7 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85356F",
    d: "m23.2 27.8-17-10a5.4 5.4 0 0 1-1.9-7.3L25.8 23l-2.6 4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#662955",
    d: "M26 28H5.2A5.3 5.3 0 0 1 0 22.7h26V28Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h136v28H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbletoLogo);
export default __webpack_public_path__ + "static/media/ableto_logo.0001bc479211fc3107489ba5b963590e.svg";
export { ForwardRef as ReactComponent };